import { useModal } from '@/components/ModalContext';
import { SuccessModal } from '@lib/sc-eone-ui/src/modal/success';
import { ConfirmationModal } from 'eone-ui/common-modals/confirmation-modal';
import { ErrorModal } from 'eone-ui/common-modals/error-modal';
import type { ModalButtonType } from 'eone-ui/modal/modal-constants';
import { useCallback } from 'react';

type ConfirmationModalProps = {
  Title?: string;
  Message?: string;
  ConfirmLabel?: string;
  CancelLabel?: string;
  ConfirmType?: ModalButtonType;
  Data?: any;
};

type ErrorModalProps = {
  Title?: string;
  Error?: { description: string };
};

type SuccessModalProps = {
  Title?: string;
  Message?: string;
  ButtonLabel?: string;
  ButtonType?: ModalButtonType;
};

function useHintModals() {
  const { show } = useModal();

  const showConfirmationModal = useCallback(async (props: ConfirmationModalProps) => {
    const res = await show<boolean>(({ close, result }) => (
      <ConfirmationModal
        {...props}
        Show
        OnConfirm={() => result(props.Data ?? true)}
        Close={close}
      />
    ));
    return res;
  }, []);

  const showErrorModal = useCallback(async (props: ErrorModalProps) => {
    const res = await show<boolean>(({ close }) => <ErrorModal {...props} Show OnCancel={close} />);
    return res;
  }, []);

  const showSuccessModal = useCallback(async (props: SuccessModalProps) => {
    const res = await show<boolean>(({ close }) => <SuccessModal {...props} Show Close={close} />);
    return res;
  }, []);

  return {
    showConfirmationModal,
    showErrorModal,
    showSuccessModal,
  };
}

export default useHintModals;
